import {
  useChemicalElements,
  useMaterials,
  useSearch,
} from "contexts/search/SearchContextProvider";
import {
  SearchChemicalElements,
  SearchMaterials,
  SearchMaterialChemistry,
  SyncedContextData,
} from "contexts/search/context";
import { useMaterialChemistryOverrides } from "hooks/search";
import { Loaded, liftLoadedState, mapLoaded } from "models/loaded";
import { MaterialChemistry } from "store/api/generatedApi";

export interface MaterialOverridesDependencies {
  materials: SearchMaterials;
  chemicalElements: SearchChemicalElements;
  materialChemistry: SearchMaterialChemistry;
  materialChemistryOverrides: MaterialChemistry[];
  searchContext: SyncedContextData;
}

export const useMaterialOverridesDependencies =
  (): Loaded<MaterialOverridesDependencies> => {
    const [materialChemistryOverrides] = useMaterialChemistryOverrides();
    const materials = useMaterials();
    const chemicalElements = useChemicalElements();
    const { context } = useSearch();

    return mapLoaded(
      liftLoadedState({
        materials,
        chemicalElements,
        context,
        materialChemistryOverrides,
      }),
      ({
        materials,
        chemicalElements,
        context,
        materialChemistryOverrides,
      }) => ({
        materials,
        chemicalElements,
        materialChemistry: context.materialChemistry,
        materialChemistryOverrides,
        searchContext: context,
      })
    );
  };
